<script setup lang="ts">
const error = useError()

onMounted(() => {
  if (error.statusCode === 404) {
    window.location.reload()
  }
});
</script>

<template>
  <NuxtLayout name="error">
    <div class="mt-10 container">
      <template v-if="error?.statusCode === 404">
        <div></div>
      </template>
    </div>
  </NuxtLayout>
</template>